import { useUsuario } from "../../../../providers/usuarioProvider";

type Props = {
  renderAssinante?: () => JSX.Element;
  renderNaoAssinante?: () => JSX.Element;
};

export default function AssinanteSwitch({
  renderAssinante = () => <></>,
  renderNaoAssinante = () => <></>,
}: Props) {
  const { isLoading, claims } = useUsuario();
  if (isLoading) return <></>;
  if (!!!claims?.stripeRole) return renderNaoAssinante();
  else return renderAssinante();
}
